import { render } from "./StoryItem.vue?vue&type=template&id=72d736dc&ts=true"
import script from "./StoryItem.vue?vue&type=script&lang=ts"
export * from "./StoryItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__